import { useCallback } from 'react';
import { IGetAceInstance } from './interfaces';

export const GetAceInstance = (data: IGetAceInstance) => {
  const { aceRef } = data;
  return useCallback(() => aceRef.current, [aceRef]);
};
